import staffarea from './index.vue'

export default [
  {
    path: '/landing-staff',
    name: 'landing-staff',
    component: staffarea,
  }
]
